<template>
  <span class="text-neutral">
    TDS <span v-if="props.percentage">({{ props.percentage }}%)</span>
  </span>
  <PTooltip
    :offset="[0, 6]"
    anchor="center left"
    self="center right"
    max-width="500px"
  >
    {{ props.hoverMessage }}
  </PTooltip>
</template>

<script setup>
const props = defineProps({
  percentage: {
    type: Number,
    default: 0,
  },
  hoverMessage: {
    type: String,
    default: "TDS Payable U/S 194Q [0.1%]",
  },
});
</script>
